
export const getFullUrl = (path = '', subdomain) => {
  if (/^https?:\/\//.test(path)) return path;

  const protocol = window.location.protocol;
  let host = window.location.host || '';
  const wwwIndex = host.indexOf('www.');

  if (subdomain && wwwIndex !== -1) {
    host = `${subdomain}.${host.substring(wwwIndex + 4)}`;
  } else if (subdomain) {
    host = `${subdomain}.${host}`;
  }

  return `${protocol}//${host}${path}`;
};

export const appendQueryString = (url, queryString) => {
  if (!queryString) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${queryString}`;
};

const BRAND_NAMES = {
  shipsticks: 'ShipSticks',
  shipplay: 'Ship&Play',
  shipcamps: 'ShipCamps',
  shipskis: 'ShipSkis',
  shipgo: 'ShipGo'
};

export const brandName = (brandId) => {
  if (!brandId) return 'ShipSticks';
  return BRAND_NAMES[brandId.toLowerCase()] || 'ShipSticks';
};

import shipsticksLogo from '../images/footer_logo_svgs/shipsticks.svg';
import shipgoLogo from '../images/footer_logo_svgs/shipgo.svg';
import shipskisLogo from '../images/footer_logo_svgs/shipskis.svg';
import shipcampsLogo from '../images/footer_logo_svgs/shipcamps.svg';
import luggagefreeLogo from '../images/footer_logo_svgs/luggagefree.svg';
import shipplayLogo from '../images/footer_logo_svgs/ship&play.svg';

export const FOOTER_LOGOS = {
  shipsticks: shipsticksLogo,
  shipgo: shipgoLogo,
  shipskis: shipskisLogo,
  shipcamps: shipcampsLogo,
  luggagefree: luggagefreeLogo,
  'ship&play': shipplayLogo,
};

export const formatBrandName = (brand) => {
  if (typeof brand !== 'string') return '';
  return brand.replace(/\s+/g, '');
};

export const lowerCaseBrandName = (brand) => {
  if (typeof brand !== 'string') return '';
  return brand.replace(/\s+/g, '').toLowerCase();
};

export const supportHostnameFor = (brand) => {
  const b = formatBrandName(brand).toLocaleLowerCase();
  return `${b}.com`;
};

export const parseCssString = (css) => {
  if (!css) return undefined;
  return css.split(';').reduce((acc, rule) => {
    const [prop, ...rest] = rule.split(':');
    const value = rest.join(':').trim();
    if (prop && value) {
      const camelProp = prop.trim().replace(/-([a-z])/g, (_, c) => c.toUpperCase());
      acc[camelProp] = value;
    }
    return acc;
  }, {});
};

export const formatLocation = function(location) {
    if (location) {
      if(location.formattedAddress) {
        return location.formattedAddress.split('<br>')[0]
      } else {
        return location.formatted_address?.split('<br>')[0]
      }
    }
  }
